import { useTranslator } from 'tradera/lang/translate';
import * as errorCodes from 'tradera/components/bank-id/state/bank-id/error-codes';

type BankIdErrorProps = {
    errorCode?: string | null;
};

export const BankIdError = ({ errorCode }: BankIdErrorProps) => {
    const { t } = useTranslator();

    let errorMessage = '';
    switch (errorCode) {
        case errorCodes.START_FAILED:
            errorMessage = t('bankId_error_start_failed');
            break;
        case errorCodes.EXPIRED_TRANSACTION:
            errorMessage = t('bankId_error_expired_transaction');
            break;
        case errorCodes.ALREADY_IN_PROGRESS:
            errorMessage = t('bankId_error_already_in_progress');
            break;
        case errorCodes.CERTIFICATE_ERROR:
            errorMessage = t('bankId_error_certificate_error');
            break;
        case errorCodes.CANCELLED:
            errorMessage = t('bankId_error_cancelled');
            break;
        case errorCodes.USER_CANCEL:
            errorMessage = t('bankId_error_user_cancel');
            break;
        default:
            errorMessage = t('bankId_error_default');
    }

    return <p>{errorMessage}</p>;
};
